import React from "react";
import Reveal from "./Reveal";
import { experienceData } from "./Constants";

const Experience = () => {
  return (
    <div id="contact" className="w-full text-black bg-[#11071F]">
      <div className="flex flex-col justify-center w-full h-full max-w-screen-lg p-4  pt-16 mx-auto text-white">
        <div className="fadein">
          <Reveal slidePermission={false}>
            <p className="inline p-2 text-4xl font-bold text-white border-b4 border-gray500">
              Experience
            </p>
          </Reveal>

          <Reveal slidePermission={false}>
            <p className="py-1 px-2 text-gray-500">
              These are the companies I've worked with
            </p>
          </Reveal>
        </div>
        {/* <Reveal slidePermission={false}>
          <div className="p-2 px-3 duration-500 rounded-lg  cursor-pointer flex flex-col gap-1  bg-transparent !border[#20b2aa26] dark:!border[#404040]  border2  fadein mt-4">
            <div className="flex justify-between items-center">
              <Reveal slidePermission={true}>
                <div className=" text-[14px] md:text-[18px] text-white  font-bold">
                  Teckat Services Private Limited
                </div>
              </Reveal>

              <Reveal slidePermission={true}>
                <div className="bg[#20b2aa26]  w-fit text-[#CCD6F6] py-[2px] px-2 md:text-base text-[12px] font-normal rounded-sm">
                  March 2024 - Present
                </div>
              </Reveal>
            </div>

            <div className="flex justify-between items-center translate-y-[-5px]">
              <Reveal slidePermission={true}>
                <div className=" text-[13px] md:text-[18px] text-[#9857D3] font-bold">
                  Jr. Software Developer
                </div>
              </Reveal>

              <Reveal slidePermission={true}>
                <div className="w-fit text-gray-500 py-[2px] px-2 md:text-base text-[13px] font-normal rounded-sm">
                  Jamshedpur
                </div>
              </Reveal>
            </div>

            <div className="text-[#CCD6F6]  text-sm md:text-[16px] leading-6  font-light flex flex-col gap-1 mt-2  pl7">
              <Reveal slidePermission={true}>
                <span className="list-disc">
                  Collaborating with the design team to build beautiful,
                  responsive, and cross-browser-compatible web pages. Developed
                  intuitive and engaging user interfaces using modern frontend
                  technologies to enhance user experience. and Integrated
                  RESTful APIs into the ReactJS frontend to ensure seamless data
                  handling and real-time functionality.
                </span>
              </Reveal>
            </div>
            <div className="mt-2 flex  md:gap-x-4 gap-x-2 gap-y-2 items-center flex-wrap">
              <div className="bg-[#150f28] hover:bg-[#1d1537] hover:translate-y-[-5px] duration-200 md:text-[16px] text-[14px] py-[2px] font-medium px-[10px]  rounded-xl w-fitt text-[#9857D3]">
                React Js
              </div>
              <div className="bg-[#150f28] hover:bg-[#1d1537] hover:translate-y-[-5px] duration-200 md:text-[16px] text-[14px] py-[2px] font-medium px-[10px]  rounded-xl w-fit text-[#9857D3]">
                Next Js
              </div>
              <div className="bg-[#150f28] hover:bg-[#1d1537] hover:translate-y-[-5px] duration-200 md:text-[16px] text-[14px] py-[2px] font-medium px-[10px]  rounded-xl w-fit text-[#9857D3]">
                React Native
              </div>
              <div className="bg-[#150f28] hover:bg-[#1d1537] hover:translate-y-[-5px] duration-200 md:text-[16px] text-[14px] py-[2px] font-medium px-[10px]  rounded-xl w-fit text-[#9857D3]">
                Ionic
              </div>
              <div className="bg-[#150f28] hover:bg-[#1d1537] hover:translate-y-[-5px] duration-200 md:text-[16px] text-[14px] py-[2px] font-medium px-[10px]  rounded-xl w-fit text-[#9857D3]">
                Typescript
              </div>
              <div className="bg-[#150f28] hover:bg-[#1d1537] hover:translate-y-[-5px] duration-200 md:text-[16px] text-[14px] py-[2px] font-medium px-[10px]  rounded-xl w-fit text-[#9857D3]">
                Tailwind Css
              </div>
              <div className="bg-[#150f28] hover:bg-[#1d1537] hover:translate-y-[-5px] duration-200 md:text-[16px] text-[14px] py-[2px] font-medium px-[10px]  rounded-xl w-fit text-[#9857D3]">
                Scss
              </div>
            </div>
          </div>
        </Reveal> */}

        <div className="relative mt-8 mx-3">
          <div className="block absolute left-1.5 top-0 bottom-0 w-0.5 bg-[#3d2b70a6]" />

          {experienceData.map((exp, index) => {
            const isLast = index === experienceData.length - 1;

            return (
              <div key={index} className="relative pb-12 ml-0 pl-7">
                {isLast && (
                  <span className="absolute left-0 top-0 w-3 h-3 rounded-full ring-4 ring-[#9857D3] animate-ping" />
                )}
                <span className="absolute left-0 top-0 w-3 h-3 rounded-full bg-[#9857D3] z-10" />

                <Reveal slidePermission={false}>
                  <div className="flex flex-col space-y-3">
                    <p className="flex items-center text-sm font-medium text-gray-400 pt-1">
                      {exp.dates}
                    </p>

                    <div>
                      <div className="text-xl font-semibold text-white">
                        {exp.title}
                      </div>
                      <p className="text-[#CCD6F6] flex items-center mt-1 text-base">
                        {exp.company} -{" "}
                        <span className="text-gray-400 ml-1.5">
                          {exp.location}
                        </span>
                      </p>
                    </div>

                    <ul className="list-disc list-outside  space-y-2 marker:text-[#CCD6F6] pl-5">
                      {exp.description.map((item, index) => (
                        <li
                          key={index}
                          className="md:text-base text-sm text-[#CCD6F6] leading-relaxed"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>

                    <div className="flex flex-wrap gap-2 pt-2">
                      {exp.skills.map((skill, index) => (
                        <span
                          key={index}
                          className="bg-[#231a3fa6] cursor-pointer hover:bg-[#3d2b70a6] hover:translate-y-[-5px] duration-200 text-[14px]  py-[2px] font-medium px-[10px]  rounded-xl w-fit text-[#9857D3]"
                        >
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                </Reveal>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Experience;
